import { sensitiveKeywordsToast } from 'helpers/toastMessages';

export const headerData = {
  tableName: 'Keywords',
  hasSearch: true,
  hasDelete: true,
  hasEdit: true,
  hasPaging: true,
  hasDefault: true,
  deleteSubtext: sensitiveKeywordsToast.deleteConfirmation,
  fields: [
    {
      fieldName: 'keyword',
      headerName: 'Keyword',
      hasSort: true,
    },
  ],
};
